import { useRouter } from "next/router"
import { t } from "translations"

import { styled } from "@mui/material/styles"

import Link from "Components/Link"

export default function SkipToContent() {
    const router = useRouter()
    return (
        <SkipLink href={`${router.asPath}#layout-container`}>
            {t.skipToContent}
        </SkipLink>
    )
}

const SkipLink = styled(Link)(({ theme }) => ({
    marginRight: theme.spacing(2),
    background: theme.palette.common.white,
    color: theme.palette.primary.main,
    padding: 0,
    position: "absolute",
    clip: "rect(0 0 0 0)",
    overflow: "hidden",
    transition: "transform 0.3s",
    "&:focus": {
        clip: "auto",
        height: "auto",
        width: "auto",
        position: "fixed",
        zIndex: 99999,
        padding: theme.spacing(3),
        top: theme.spacing(3),
        left: theme.spacing(3)
    }
}))
